import sanitizeHtml from "sanitize-html"
import multiUserPlanManagementApi from "@/api/multi-user-plan-management"
import events from "@/bl-events/index"
import i18n from "@/modules/i18n"
import store from "@/store"

const state = {
  hasB2cOrg: null,
  inviteLink: null,
  invitees: null,
  isFull: null,
  memberToRemove: null,
  eligibleForMUP: false,
  userName: null
}

const mutations = {
  hasB2cOrg: (state, payload) => {
    state.hasB2cOrg = payload
  },
  eligibleForMUP: (state, payload) => {
    state.eligibleForMUP = payload
  },
  inviteLink: (state, payload) => {
    state.inviteLink = payload
  },
  invitees: (state, payload) => {
    state.invitees = payload
  },
  isFull: (state, payload) => {
    state.isFull = payload
  },
  memberToRemove: (state, payload) => {
    state.memberToRemove = payload
  },
  userName: (state, payload) => {
    state.userName = payload
  }
}

const actions = {
  fetchOwnerOrg: async ({ commit }) => {
    try {
      const res = await multiUserPlanManagementApi.fetchOwnerOrg()
      commit("eligibleForMUP", res.mupEligible)
      commit("invitees", res.invitees)
      commit("inviteLink", res.inviteLink)
      commit("hasB2cOrg", !!res.organisationId)
      commit("isFull", res.isFull)
    } catch (_) {
      commit("hasB2cOrg", false)
    }
  },
  createOwnerOrg: ({ commit }, inviterName) => {
    const sanitizedInviterName = sanitizeHtml(inviterName, { allowedTags: [], allowedAttributes: {} })
    return multiUserPlanManagementApi
      .createOwnerOrg(sanitizedInviterName)
      .then((res) => {
        if (res.status === "error") {
          throw res.message
        } else {
          commit("hasB2cOrg", true)
          commit("inviteLink", res.inviteLink)
          commit("invitees", res.invitees)
          commit("isFull", res.isFull)
          commit("userName", sanitizedInviterName)
          events.track("mup_settings_members_shown", "1-show")
        }
      })
      .catch(() => {
        commit("hasB2cOrg", false)
      })
  },
  fetchUserName: async ({ commit }) => {
    return multiUserPlanManagementApi
      .getUserName()
      .then((response) => {
        commit("userName", response.name)
        if (response.status === "error") {
          store.dispatch(
            "toaster/push",
            {
              id: "mup-user-name-fetch-error",
              message: i18n.t("pages.settings.mup.name_fetch_error"),
              type: "error"
            },
            { root: true }
          )
        }
      })
      .catch(() => {
        /* No UI feedback on error */
      })
      .finally(() => {
        setTimeout(() => store.dispatch("toaster/pop", "mup-user-name-fetch-error"), 3000)
      })
  },
  triggerNameChange: ({ commit }, newName) => {
    multiUserPlanManagementApi
      .changeName(newName)
      .then(() => {
        commit("userName", newName)
        store.dispatch("toaster/push", {
          id: "change-name-success",
          type: "success",
          message: i18n.t("pages.settings.mup.updateNameSuccess")
        })
      })
      .catch(() => {
        store.dispatch(
          "toaster/push",
          {
            id: "api/change-name-error",
            message: i18n.t("errors.generic"),
            type: "error"
          },
          { root: true }
        )
      })
      .finally(() => {
        setTimeout(() => store.dispatch("toaster/pop", "change-name-success"), 3000)
      })
  },
  triggerRemoveUserModal: ({ commit }, member) => {
    events.emit("modal:remove-mup-member-modal:open")
    commit("memberToRemove", member)
  },
  removeUser: ({ state, dispatch }) => {
    return multiUserPlanManagementApi
      .removeMemberFromOrg(state.memberToRemove.userId)
      .then((res) => {
        if (res.status === "error") {
          throw res.message
        } else {
          store.dispatch(
            "toaster/push",
            {
              id: "api/removeUserSuccess",
              message: i18n.t("pages.settings.mup.userRemovedSuccess", { email: state.memberToRemove.email }),
              type: "success"
            },
            { root: true }
          )
        }
      })
      .catch(() => {
        store.dispatch(
          "toaster/push",
          {
            id: "api/removeUserError",
            message: i18n.t("errors.generic"),
            type: "error"
          },
          { root: true }
        )
      })
      .finally(() => {
        dispatch("fetchOwnerOrg")
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
